// // components/layout/Sidebar.jsx
// import React, {
//   useState,
//   useEffect,
//   useRef,
//   useMemo,
//   useCallback,
// } from "react";
// import {
//   LayoutDashboard,
//   Package,
//   LogOut,
//   Wallet,
//   User,
//   X,
//   Home,
//   Store,
//   TrendingUp,
//   Shield,
//   ClipboardList,
//   UserPlus,
//   ChevronRight,
//   ChevronLeft,
//   ChevronDown,
//   Crown,
//   Sparkles,
//   Bell,
//   HelpCircle,
//   Copy,
//   Share2,
//   ExternalLink,
//   Check,
//   ShoppingBag,
//   SlidersHorizontal,
//   Layers,
//   BadgeCheck,
//   Clock,
//   Tags,
//   CalendarDays,
//   ReceiptText,
//   GraduationCap,
//   BookOpen,
// } from "lucide-react";
// import { useAuth } from "../../providers/AuthProvider";
// import { useTheme } from "../../hooks/useTheme";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useToast } from "../../providers/ToastProvider";
// import { useAgentContext } from "../../hooks/useAgentContext";
// import azoemartLogo from "../../assets/images/azoemart.png";

// const COLLAPSE_KEY = "sidebar_collapsed";
// const GROUPS_KEY = "sidebar_groups_open";

// /* ══════════════════════════════════════════════════════════
//    Route matching
//    ══════════════════════════════════════════════════════════ */

// /**
//  * Score how well a candidate path matches the current location.
//  * Returns 0 for no match, or a positive number where higher = more
//  * specific.
//  *
//  *   exact match          → 1000 + length  (always beats any prefix)
//  *   prefix match         → length         (longer prefix wins)
//  *   "/" only matches "/" via the exact branch
//  */
// const scoreMatch = (candidate, current) => {
//   if (!candidate || !current) return 0;
//   if (candidate === current) return 1000 + candidate.length;
//   if (candidate === "/") return current === "/" ? 1 : 0;
//   if (current.startsWith(candidate + "/")) return candidate.length;
//   return 0;
// };

// const collectLeafPaths = (nodes) => {
//   const out = [];
//   for (const node of nodes) {
//     if (node.type === "group") {
//       out.push(...collectLeafPaths(node.children || []));
//       if (node.defaultPath) out.push(node.defaultPath);
//     } else if (node.path) {
//       out.push(node.path.split("?")[0]);
//     }
//   }
//   return out;
// };

// const findBestActivePath = (pathname, leafPaths) => {
//   let best = null;
//   let bestScore = 0;
//   for (const p of leafPaths) {
//     const s = scoreMatch(p, pathname);
//     if (s > bestScore) {
//       best = p;
//       bestScore = s;
//     }
//   }
//   return best;
// };

// /* ══════════════════════════════════════════════════════════
//    Utilities
//    ══════════════════════════════════════════════════════════ */

// const initialsOf = (user) => {
//   if (!user) return "?";
//   const first = user.first_name?.[0] || "";
//   const last = user.last_name?.[0] || "";
//   if (first || last) return (first + last).toUpperCase();
//   const src = user.username || user.phone_number || "?";
//   return src.slice(0, 2).toUpperCase();
// };

// const ROLE_META = {
//   ADMIN: { label: "Admin", icon: Shield, tone: "error" },
//   AGENT: { label: "Agent", icon: Crown, tone: "warning" },
//   SUB_AGENT: { label: "Sub-agent", icon: Sparkles, tone: "link" },
//   CUSTOMER: { label: "Customer", icon: User, tone: "success" },
// };

// const ROLE_SECTION_TITLE = {
//   ADMIN: "Admin tools",
//   AGENT: "Agent tools",
//   SUB_AGENT: "Sub-agent tools",
// };

// const readOpenGroups = () => {
//   try {
//     const raw = localStorage.getItem(GROUPS_KEY);
//     return raw ? JSON.parse(raw) : {};
//   } catch {
//     return {};
//   }
// };

// const writeOpenGroups = (map) => {
//   try {
//     localStorage.setItem(GROUPS_KEY, JSON.stringify(map));
//   } catch { }
// };

// const roleToneColor = (colors, tone) => {
//   const map = {
//     warning: colors.warning,
//     error: colors.error,
//     link: colors.linkColor,
//     success: colors.success,
//   };
//   return map[tone] || colors.secondaryText;
// };

// /* ══════════════════════════════════════════════════════════
//    Sidebar
//    ══════════════════════════════════════════════════════════ */

// const Sidebar = ({ isOpen, isMobile, onClose }) => {
//   const { user, logout, isAuthenticated, authFetch } = useAuth();
//   const { colors } = useTheme();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { showToast } = useToast();
//   const { agent } = useAgentContext();

//   const [isSubAgentOfThisAgent, setIsSubAgentOfThisAgent] = useState(false);
//   const [isLoading, setIsLoading] = useState(true);
//   const [isCollapsed, setIsCollapsed] = useState(() => {
//     try {
//       return localStorage.getItem(COLLAPSE_KEY) === "1";
//     } catch {
//       return false;
//     }
//   });
//   const [openGroups, setOpenGroups] = useState(readOpenGroups);
//   const [hoveredPath, setHoveredPath] = useState(null);
//   const [copiedStoreUrl, setCopiedStoreUrl] = useState(false);
//   const hasFetched = useRef(false);

//   useEffect(() => {
//     try {
//       localStorage.setItem(COLLAPSE_KEY, isCollapsed ? "1" : "0");
//     } catch { }
//   }, [isCollapsed]);

//   useEffect(() => {
//     writeOpenGroups(openGroups);
//   }, [openGroups]);

//   const collapsed = isMobile ? false : isCollapsed;

//   /* ── Store context resolution ────────────────────────── */
//   const storeContext = useMemo(
//     () =>
//       agent
//         ? {
//           type: agent.agent?.role === "AGENT" ? "agent" : "subagent",
//           id: agent.agent?.id,
//           storeUrl: agent.profile?.store_url,
//           shopName: agent.profile?.shop_name,
//           role: agent.agent?.role,
//         }
//         : null,
//     [agent]
//   );

//   const userAgentStoreUrl =
//     user?.agent_profile?.store_url ||
//     user?.store_url ||
//     (user?.role === "AGENT" ? user?.username : null);

//   const displayStoreUrl = storeContext?.storeUrl || userAgentStoreUrl;
//   const fullStoreUrl = useMemo(() => {
//     if (!displayStoreUrl) return null;
//     const clean = displayStoreUrl
//       .replace(/^https?:\/\//, "")
//       .replace(/\/$/, "");
//     return `https://${clean}.azoeshop.store`;
//   }, [displayStoreUrl]);

//   const displayShopName =
//     storeContext?.shopName ||
//     user?.agent_profile?.shop_name ||
//     user?.username ||
//     "My Store";

//   const isAgentStore = storeContext?.role === "AGENT" || user?.role === "AGENT";
//   const isSubAgentStore =
//     storeContext?.role === "SUB_AGENT" || user?.role === "SUB_AGENT";

//   /* ── Sub-agent-of-this-agent probe ───────────────────── */
//   useEffect(() => {
//     if (
//       isAuthenticated &&
//       storeContext?.type === "agent" &&
//       user?.role !== "AGENT" &&
//       !hasFetched.current
//     ) {
//       hasFetched.current = true;
//       setIsLoading(true);
//       authFetch(`/accounts/agents/${storeContext.id}/sub-agents/`)
//         .then((r) => r.json())
//         .then((data) => {
//           if (data.status === "success") {
//             const subs = data.data?.sub_agents || [];
//             setIsSubAgentOfThisAgent(
//               subs.some((sa) => sa.user_id === user.id)
//             );
//           }
//         })
//         .catch((e) => console.error("sub-agent check:", e))
//         .finally(() => setIsLoading(false));
//     } else {
//       setIsLoading(false);
//       if (
//         !isAuthenticated ||
//         storeContext?.type !== "agent" ||
//         user?.role === "AGENT"
//       ) {
//         hasFetched.current = false;
//       }
//     }
//   }, [isAuthenticated, storeContext, user?.role, user?.id, authFetch]);

  
//   /* ── Derived display helpers ──────────────────────────── */
//   const roleMeta = ROLE_META[user?.role] || null;

//   const shouldShowStoreUrl =
//     !!fullStoreUrl &&
//     ((isAuthenticated &&
//       (user?.role === "AGENT" || user?.role === "SUB_AGENT")) ||
//       !!storeContext);

//   /* ── Handlers ─────────────────────────────────────────── */
//   const handleLogout = useCallback(async () => {
//     try {
//       await logout();
//       showToast("Logged out successfully", "success");
//       navigate("/login");
//     } catch {
//       showToast("Logout failed", "error");
//     }
//   }, [logout, navigate, showToast]);

//   const handleCopyStoreUrl = useCallback(async () => {
//     if (!fullStoreUrl) return;
//     try {
//       await navigator.clipboard.writeText(fullStoreUrl);
//       setCopiedStoreUrl(true);
//       showToast("Store URL copied", "success");
//       setTimeout(() => setCopiedStoreUrl(false), 2000);
//     } catch {
//       showToast("Failed to copy URL", "error");
//     }
//   }, [fullStoreUrl, showToast]);

//   const handleOpenStoreUrl = useCallback(() => {
//     if (fullStoreUrl) window.open(fullStoreUrl, "_blank");
//   }, [fullStoreUrl]);

//   const handleShareStoreUrl = useCallback(async () => {
//     if (!fullStoreUrl) return;
//     if (navigator.share) {
//       try {
//         await navigator.share({
//           title: `${displayShopName} - Azoemart`,
//           text: `Check out ${displayShopName} on Azoemart!`,
//           url: fullStoreUrl,
//         });
//         return;
//       } catch (e) {
//         if (e.name === "AbortError") return;
//       }
//     }
//     handleCopyStoreUrl();
//   }, [fullStoreUrl, displayShopName, handleCopyStoreUrl]);

//   /* ══════════════════════════════════════════════════════
//      Navigation tree
//      ══════════════════════════════════════════════════════ */

//   const customerMarketplaceGroup = useMemo(
//     () => ({
//       type: "group",
//       id: "marketplace",
//       icon: Store,
//       label: "Marketplace",
//       defaultPath: "/marketplace",
//       children: [
//         {
//           path: "/marketplace",
//           icon: Layers,
//           label: "Shop",
//           exact: true,
//         },
//         {
//           path: "/dropshipping",
//           icon: TrendingUp,
//           label: "Ready to ship",
//         },
//         {
//           path: "/marketplace?filter=ghana",
//           icon: BadgeCheck,
//           label: "Available in Ghana",
//           matchQuery: { filter: "ghana" },
//         },
//         {
//           path: "/preorder",
//           icon: Clock,
//           label: "Pre-order windows",
//         },
//       ],
//     }),
//     []
//   );

//   const buildAdminMarketplaceGroup = (role) => {
//     const isAdmin = role === "ADMIN";

//     const children = [
//       {
//         path: "/marketplace/manage",
//         icon: LayoutDashboard,
//         label: "Overview",
//         exact: true,
//       },
//     ];

//     if (isAdmin) {
//       children.push(
//         { path: "/marketplace/manage/categories", icon: Tags, label: "Categories" },
//         { path: "/marketplace/manage/products", icon: Package, label: "Products" },
//         { path: "/marketplace/manage/campaigns", icon: CalendarDays, label: "Campaigns" }
//       );
//     }

//     children.push(
//       { path: "/marketplace/manage/pricing", icon: SlidersHorizontal, label: "Pricing" },
//       { path: "/marketplace/manage/orders", icon: ReceiptText, label: "Orders" }
//     );

//     return {
//       type: "group",
//       id: "marketplace-admin",
//       icon: Store,
//       label: "Marketplace admin",
//       defaultPath: "/marketplace/manage",
//       children,
//     };
//   };


//   const buildCoursesGroup = (role) => {
//     const isAdmin = role === "ADMIN";
//     const children = [];

//     if (isAdmin) {
//       children.push(
//         { path: "/courses/manage/catalog", icon: BookOpen, label: "Catalog" },
//         { path: "/courses/manage/enrollments", icon: ReceiptText, label: "Enrollments" }
//       );
//     }
//     children.push({
//       path: "/courses/manage/pricing",
//       icon: SlidersHorizontal,
//       label: "Pricing",
//     });

//     return {
//       type: "group",
//       id: "courses-admin",
//       icon: GraduationCap,
//       label: "Courses",
//       defaultPath: "/courses/manage",
//       children,
//     };
//   };

//   /* ── Build link tree by role ─────────────────────────── */
//   const navTree = useMemo(() => {
//     const base = [
//       { type: "link", path: "/", icon: Home, label: "Home" },
//       { type: "link", path: "/data", icon: TrendingUp, label: "Data Services" },
//       customerMarketplaceGroup,
//       { type: "link", path: "/orders", icon: ClipboardList, label: "Data Orders" },
//       {
//         type: "link",
//         path: "/marketplace/orders",
//         icon: ShoppingBag,
//         label: "Marketplace Orders",
//       },
//       { type: "link", path: "/notices", icon: Bell, label: "Notices" },
//     ];

//     const showSubAgent =
//       (storeContext?.type === "agent" && !isAuthenticated) ||
//       (storeContext?.type === "agent" &&
//         isAuthenticated &&
//         !isSubAgentOfThisAgent &&
//         user?.role !== "AGENT" &&
//         !isLoading);

//     if (showSubAgent) {
//       base.push({
//         type: "link",
//         path: "/subagent/register",
//         icon: UserPlus,
//         label: "Become Sub-Agent",
//         isSpecial: true,
//       });
//     }

//     const roleNodes = [];
//     switch (user?.role) {
//       case "CUSTOMER":
//         roleNodes.push({
//           type: "link",
//           path: "/become-agent",
//           icon: UserPlus,
//           label: "Become Agent",
//           isSpecial: true,
//         });
//         break;
//       case "ADMIN":
//         roleNodes.push(
//           { type: "link", path: "/admin/dashboard", icon: LayoutDashboard, label: "Dashboard" },
//           { type: "link", path: "/admin/users", icon: User, label: "Manage Users" },
//           { type: "link", path: "/admin/data-packages", icon: Package, label: "Data Packages" },
//           buildAdminMarketplaceGroup(user.role),
//           buildCoursesGroup(user.role),
//           { type: "link", path: "/admin/withdrawals", icon: Wallet, label: "Withdrawals" },
//           { type: "link", path: "/admin/notices", icon: Bell, label: "Manage Notices" }
//         );
//         break;
//       case "AGENT":
//         roleNodes.push(
//           { type: "link", path: "/agent/dashboard", icon: LayoutDashboard, label: "Dashboard" },
//           buildAdminMarketplaceGroup(user.role),
//           buildCoursesGroup(user.role),
//           { type: "link", path: "/agent/subagents", icon: User, label: "Sub Agents" },
//           { type: "link", path: "/agent/withdrawals", icon: Wallet, label: "Withdrawals" }
//         );
//         break;
//       case "SUB_AGENT":
//         roleNodes.push(
//           { type: "link", path: "/subagent/dashboard", icon: LayoutDashboard, label: "Dashboard" },
//           buildAdminMarketplaceGroup(user.role),
//           buildCoursesGroup(user.role),
//           { type: "link", path: "/subagent/withdrawals", icon: Wallet, label: "Withdrawals" }
//         );
//         break;
//       default:
//         break;
//     }

//     // Unpaid agents: hide write-only nav items so they don't hit 403.
//     // Reads (dashboard, orders list, etc.) remain visible.
//     if (user?.is_unpaid_agent) {
//       const WRITE_PATHS = new Set([
//         "/agent/withdrawals",
//         "/subagent/withdrawals",
//         "/admin/withdrawals",
//         "/agent/subagents",
//         "/subagent/register",
//       ]);
//       const prune = (nodes) =>
//         nodes
//           .filter((n) => !WRITE_PATHS.has(n.path))
//           .map((n) =>
//             n.type === "group"
//               ? { ...n, children: prune(n.children || []) }
//               : n
//           );
//       roleNodes.splice(0, roleNodes.length, ...prune(roleNodes));
//     }

//     return { base, roleNodes };
//   }, [
//     user?.role,
//     storeContext,
//     isAuthenticated,
//     isSubAgentOfThisAgent,
//     isLoading,
//     customerMarketplaceGroup,
//   ]);

//   /* ══════════════════════════════════════════════════════
//      Active leaf resolution
//      ══════════════════════════════════════════════════════ */

//   const allLeafPaths = useMemo(() => {
//     const all = [...navTree.base, ...navTree.roleNodes];
//     return collectLeafPaths(all);
//   }, [navTree]);

//   const bestActivePath = useMemo(
//     () => findBestActivePath(location.pathname, allLeafPaths),
//     [location.pathname, allLeafPaths]
//   );

//   const activeGroups = useMemo(() => {
//     const set = new Set();
//     const visit = (nodes) => {
//       for (const node of nodes) {
//         if (node.type === "group") {
//           const children = node.children || [];
//           const hasActiveChild =
//             children.some(
//               (c) =>
//                 scoreMatch(c.path.split("?")[0], location.pathname) > 0 &&
//                 c.path.split("?")[0] === bestActivePath
//             ) || node.defaultPath === bestActivePath;
//           if (hasActiveChild) set.add(node.id);
//           visit(children);
//         }
//       }
//     };
//     visit(navTree.base);
//     visit(navTree.roleNodes);
//     return set;
//   }, [navTree, bestActivePath, location.pathname]);

//   useEffect(() => {
//     if (activeGroups.size === 0) return;
//     setOpenGroups((prev) => {
//       let changed = false;
//       const next = { ...prev };
//       activeGroups.forEach((id) => {
//         if (!next[id]) {
//           next[id] = true;
//           changed = true;
//         }
//       });
//       return changed ? next : prev;
//     });
//   }, [activeGroups]);

//   const toggleGroup = (id) =>
//     setOpenGroups((prev) => ({ ...prev, [id]: !prev[id] }));

//   /* ══════════════════════════════════════════════════════
//      Rendering helpers
//      ══════════════════════════════════════════════════════ */

//   const currentParams = useMemo(
//     () => new URLSearchParams(location.search),
//     [location.search]
//   );

//   const isLeafActive = useCallback(
//     (leaf) => {
//       if (leaf.matchQuery) {
//         if (scoreMatch(leaf.path.split("?")[0], location.pathname) === 0)
//           return false;
//         return Object.entries(leaf.matchQuery).every(
//           ([k, v]) => currentParams.get(k) === v
//         );
//       }
//       if (leaf.exact) {
//         return scoreMatch(leaf.path, location.pathname) >= 1000;
//       }
//       return leaf.path === bestActivePath;
//     },
//     [location.pathname, currentParams, bestActivePath]
//   );

//   /* ── Sub-components ───────────────────────────────────── */

//   const LeafItem = ({ leaf, isChild = false }) => {
//     const Icon = leaf.icon;
//     const active = isLeafActive(leaf);
//     const hovered = hoveredPath === leaf.path;

//     const handleClick = (e) => {
//       if (leaf.external) {
//         e.preventDefault();
//         window.open(leaf.path, "_blank", "noopener");
//         return;
//       }
//       navigate(leaf.path);
//       if (isMobile) onClose();
//     };

//     return (
//       <button
//         type="button"
//         onClick={handleClick}
//         onMouseEnter={() => setHoveredPath(leaf.path)}
//         onMouseLeave={() => setHoveredPath(null)}
//         style={{
//           position: "relative",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: collapsed ? "center" : "flex-start",
//           gap: collapsed ? 0 : 12,
//           width: "100%",
//           padding: collapsed
//             ? "10px"
//             : isChild
//               ? "8px 12px 8px 34px"
//               : isMobile
//                 ? "11px 12px"
//                 : "9px 12px",
//           borderRadius: 8,
//           background: active
//             ? colors.activeBg
//             : hovered
//               ? colors.hoverBg
//               : "transparent",
//           color: active
//             ? colors.btnBg
//             : leaf.isSpecial
//               ? colors.btnBg
//               : colors.text,
//           border: "1px solid transparent",
//           cursor: "pointer",
//           transition: "background 0.14s ease, color 0.14s ease",
//           marginBottom: 2,
//           fontWeight: active ? 700 : 500,
//           fontSize: isChild ? (isMobile ? 13.5 : 12.5) : isMobile ? 14 : 13.5,
//           fontFamily: "inherit",
//         }}
//       >
//         {active && !isChild && (
//           <span
//             style={{
//               position: "absolute",
//               left: collapsed ? "50%" : 0,
//               transform: collapsed
//                 ? "translate(-50%, -50%)"
//                 : "translateY(-50%)",
//               top: collapsed ? "auto" : "50%",
//               bottom: collapsed ? 4 : "auto",
//               width: collapsed ? 16 : 3,
//               height: collapsed ? 3 : 20,
//               borderRadius: 2,
//               background: colors.btnBg,
//             }}
//           />
//         )}

//         <Icon
//           size={collapsed ? 20 : isChild ? 14 : isMobile ? 18 : 16}
//           strokeWidth={active ? 2.4 : isChild ? 1.9 : 2}
//           style={{ flexShrink: 0 }}
//         />

//         {!collapsed && (
//           <>
//             <span
//               style={{
//                 flex: 1,
//                 textAlign: "left",
//                 whiteSpace: "nowrap",
//                 overflow: "hidden",
//                 textOverflow: "ellipsis",
//               }}
//             >
//               {leaf.label}
//             </span>
//             {leaf.isSpecial && (
//               <span
//                 style={{
//                   fontSize: 9,
//                   fontWeight: 800,
//                   padding: "2px 7px",
//                   borderRadius: 8,
//                   background: colors.btnBg,
//                   color: colors.btnText,
//                   letterSpacing: 0.4,
//                   textTransform: "uppercase",
//                 }}
//               >
//                 New
//               </span>
//             )}
//           </>
//         )}
//       </button>
//     );
//   };

//   const GroupItem = ({ group }) => {
//     const Icon = group.icon;
//     const open = !!openGroups[group.id];
//     const containsActive = activeGroups.has(group.id);
//     const hovered = hoveredPath === `group-${group.id}`;

//     const handleClick = () => {
//       if (collapsed) {
//         const target = group.defaultPath || group.children?.[0]?.path;
//         if (target) {
//           navigate(target);
//           if (isMobile) onClose();
//         }
//         return;
//       }
//       toggleGroup(group.id);
//     };

//     return (
//       <div style={{ marginBottom: 2, position: "relative" }}>
//         <button
//           type="button"
//           onClick={handleClick}
//           onMouseEnter={() => setHoveredPath(`group-${group.id}`)}
//           onMouseLeave={() => setHoveredPath(null)}
//           aria-expanded={collapsed ? undefined : open}
//           style={{
//             position: "relative",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: collapsed ? "center" : "flex-start",
//             gap: collapsed ? 0 : 12,
//             width: "100%",
//             padding: collapsed
//               ? "10px"
//               : isMobile
//                 ? "11px 12px"
//                 : "9px 12px",
//             borderRadius: 8,
//             background: containsActive
//               ? colors.activeBg
//               : hovered
//                 ? colors.hoverBg
//                 : "transparent",
//             color: containsActive ? colors.btnBg : colors.text,
//             border: "1px solid transparent",
//             cursor: "pointer",
//             transition: "background 0.14s ease, color 0.14s ease",
//             fontWeight: containsActive ? 700 : 500,
//             fontSize: isMobile ? 14 : 13.5,
//             fontFamily: "inherit",
//           }}
//         >
//           {containsActive && !collapsed && (
//             <span
//               style={{
//                 position: "absolute",
//                 left: 0,
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 width: 3,
//                 height: 20,
//                 borderRadius: 2,
//                 background: colors.btnBg,
//               }}
//             />
//           )}

//           <Icon
//             size={collapsed ? 20 : isMobile ? 18 : 16}
//             strokeWidth={containsActive ? 2.4 : 2}
//             style={{ flexShrink: 0 }}
//           />

//           {!collapsed && (
//             <>
//               <span
//                 style={{
//                   flex: 1,
//                   textAlign: "left",
//                   whiteSpace: "nowrap",
//                   overflow: "hidden",
//                   textOverflow: "ellipsis",
//                 }}
//               >
//                 {group.label}
//               </span>
//               <ChevronDown
//                 size={14}
//                 style={{
//                   color: containsActive
//                     ? colors.btnBg
//                     : colors.secondaryText,
//                   transition: "transform 0.22s ease, color 0.14s ease",
//                   transform: open ? "rotate(0deg)" : "rotate(-90deg)",
//                   flexShrink: 0,
//                 }}
//               />
//             </>
//           )}
//         </button>

//         {/* Children */}
//         {!collapsed && open && (
//           <div style={styles.groupChildren}>
//             <span
//               style={{
//                 position: "absolute",
//                 left: 20,
//                 top: 4,
//                 bottom: 4,
//                 width: 1,
//                 borderLeft: `1px dashed ${colors.separator || colors.border}`,
//                 opacity: 0.7,
//                 pointerEvents: "none",
//               }}
//             />
//             {group.children.map((leaf) => (
//               <LeafItem key={leaf.path} leaf={leaf} isChild />
//             ))}
//           </div>
//         )}

//         {/* Collapsed tooltip */}
//         {collapsed && hovered && (
//           <Tooltip colors={colors}>{group.label}</Tooltip>
//         )}
//       </div>
//     );
//   };

//   const Tooltip = ({ children, colors }) => (
//     <div
//       style={{
//         position: "absolute",
//         left: "calc(100% + 10px)",
//         top: "50%",
//         transform: "translateY(-50%)",
//         background: colors.heading,
//         color: colors.mainBg,
//         padding: "6px 12px",
//         borderRadius: 8,
//         fontSize: 12.5,
//         fontWeight: 600,
//         whiteSpace: "nowrap",
//         zIndex: 100,
//         pointerEvents: "none",
//         boxShadow: `0 6px 16px ${colors.shadowStrong}`,
//       }}
//     >
//       <span
//         style={{
//           position: "absolute",
//           left: -4,
//           top: "50%",
//           transform: "translateY(-50%) rotate(45deg)",
//           width: 8,
//           height: 8,
//           background: colors.heading,
//           borderRadius: 1,
//         }}
//       />
//       {children}
//     </div>
//   );

//   const SectionLabel = ({ children }) =>
//     collapsed ? null : (
//       <div style={styles.sectionLabel}>
//         <span style={{ color: colors.secondaryText }}>{children}</span>
//         <span
//           style={{
//             flex: 1,
//             height: 1,
//             background: colors.separator || colors.border,
//             opacity: 0.5,
//           }}
//         />
//       </div>
//     );

//   const renderNode = (node) => {
//     if (node.type === "group") {
//       return <GroupItem key={node.id} group={node} />;
//     }
//     return <LeafItem key={node.path} leaf={node} />;
//   };

//   /* ══════════════════════════════════════════════════════
//      Content
//      ══════════════════════════════════════════════════════ */
//   const content = (
//     <div
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         height: "100%",
//         backgroundColor: colors.raisedBg,
//         position: "relative",
//         overflow: "hidden",
//       }}
//     >
//       {/* ── Brand bar ───────────────────────────────────── */}
//       <div
//         style={{
//           padding: collapsed
//             ? "10px 12px"
//             : isMobile
//               ? "12px 16px"
//               : "10px 16px",
//           borderBottom: `1px solid ${colors.border}`,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: collapsed ? "center" : "space-between",
//           gap: 10,
//           minHeight: isMobile ? 64 : 60,
//         }}
//       >
//         <button
//           type="button"
//           onClick={() => {
//             navigate("/");
//             if (isMobile) onClose();
//           }}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: 10,
//             minWidth: 0,
//             cursor: "pointer",
//             background: "transparent",
//             border: "none",
//             padding: 0,
//             fontFamily: "inherit",
//           }}
//         >
//           <span style={styles.logoTile(colors, isMobile, collapsed)}>
//             <img
//               src={azoemartLogo}
//               alt=""
//               style={{
//                 width: isMobile ? 26 : collapsed ? 26 : 22,
//                 height: isMobile ? 26 : collapsed ? 26 : 22,
//                 objectFit: "contain",
//               }}
//             />
//           </span>
//           {!collapsed && (
//             <span
//               style={{
//                 fontSize: isMobile ? 15.5 : 14.5,
//                 fontWeight: 800,
//                 color: colors.heading,
//                 letterSpacing: -0.3,
//                 whiteSpace: "nowrap",
//                 overflow: "hidden",
//                 textOverflow: "ellipsis",
//               }}
//             >
//               Azoemart
//             </span>
//           )}
//         </button>

//         {!isMobile && !collapsed && (
//           <button
//             type="button"
//             onClick={() => setIsCollapsed(true)}
//             aria-label="Collapse sidebar"
//             style={iconBtnStyle(colors)}
//           >
//             <ChevronLeft size={15} />
//           </button>
//         )}

//         {!isMobile && collapsed && (
//           <button
//             type="button"
//             onClick={() => setIsCollapsed(false)}
//             aria-label="Expand sidebar"
//             style={{
//               ...iconBtnStyle(colors),
//               position: "absolute",
//               top: 16,
//               right: 8,
//             }}
//           >
//             <ChevronRight size={15} />
//           </button>
//         )}

//         {isMobile && (
//           <button
//             type="button"
//             onClick={onClose}
//             aria-label="Close menu"
//             style={{
//               ...iconBtnStyle(colors),
//               width: 36,
//               height: 36,
//               borderRadius: 9,
//               background: colors.subtleBg || colors.hoverBg,
//               border: `1px solid ${colors.border}`,
//               color: colors.text,
//             }}
//           >
//             <X size={17} />
//           </button>
//         )}
//       </div>

//       {/* ── Identity card ───────────────────────────────── */}
//       <div
//         style={{
//           padding: collapsed ? "10px 8px" : "12px 12px",
//           borderBottom: `1px solid ${colors.border}`,
//         }}
//       >
//         <div
//           style={{
//             background: colors.subtleBg || colors.hoverBg,
//             border: `1px solid ${colors.border}`,
//             borderRadius: 12,
//             padding: collapsed ? 8 : isMobile ? 12 : 10,
//             display: "flex",
//             flexDirection: "column",
//             gap: collapsed ? 0 : 10,
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: collapsed ? 0 : 10,
//               justifyContent: collapsed ? "center" : "flex-start",
//               minWidth: 0,
//             }}
//           >
//             <div
//               style={{
//                 position: "relative",
//                 width: collapsed ? 34 : isMobile ? 42 : 38,
//                 height: collapsed ? 34 : isMobile ? 42 : 38,
//                 borderRadius: 10,
//                 background: `linear-gradient(135deg, ${colors.btnBg}, ${colors.btnBg}aa)`,
//                 color: "#fff",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 flexShrink: 0,
//                 fontSize: isMobile ? 13 : 12,
//                 fontWeight: 800,
//                 letterSpacing: 0.5,
//               }}
//             >
//               {isAuthenticated ? initialsOf(user) : <User size={16} />}
//             </div>

//             {!collapsed && (
//               <div style={{ flex: 1, minWidth: 0 }}>
//                 <div
//                   style={{
//                     fontSize: isMobile ? 14 : 13.5,
//                     fontWeight: 800,
//                     color: colors.heading,
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 6,
//                     whiteSpace: "nowrap",
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                   }}
//                 >
//                   <span
//                     style={{
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       minWidth: 0,
//                     }}
//                   >
//                     {isAuthenticated
//                       ? user?.full_name ||
//                       user?.username ||
//                       user?.phone_number ||
//                       "User"
//                       : "Guest"}
//                   </span>
//                   {roleMeta && (
//                     <roleMeta.icon
//                       size={13}
//                       color={roleToneColor(colors, roleMeta.tone)}
//                       style={{ flexShrink: 0 }}
//                     />
//                   )}
//                 </div>
//                 <div
//                   style={{
//                     fontSize: 11.5,
//                     color: colors.secondaryText,
//                     marginTop: 2,
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 4,
//                   }}
//                 >
//                   <Shield size={10} />
//                   {isAuthenticated
//                     ? roleMeta?.label || user?.role?.toLowerCase() || "User"
//                     : "Not signed in"}
//                 </div>
//               </div>
//             )}
//           </div>

//           {!collapsed && user?.is_unpaid_agent && (
//             <button
//               type="button"
//               onClick={() => {
//                 navigate("/register/payment");
//                 if (isMobile) onClose();
//               }}
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 6,
//                 width: "100%",
//                 padding: "6px 8px",
//                 borderRadius: 8,
//                 background: colors.warningBg || "#FEF3C7",
//                 border: `1px solid ${colors.warning || "#F59E0B"}`,
//                 color: colors.warning || "#F59E0B",
//                 fontSize: 11,
//                 fontWeight: 700,
//                 cursor: "pointer",
//                 fontFamily: "inherit",
//               }}
//             >
//               <Clock size={12} />
//               <span style={{ flex: 1, textAlign: "left" }}>
//                 Registration payment pending
//               </span>
//               <ChevronRight size={12} />
//             </button>
//           )}

//           {!collapsed && shouldShowStoreUrl && (
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 6,
//                 padding: "6px 8px",
//                 background: colors.raisedBg,
//                 borderRadius: 8,
//                 border: `1px solid ${colors.border}`,
//               }}
//             >
//               <Store
//                 size={12}
//                 style={{ color: colors.btnBg, flexShrink: 0 }}
//               />
//               <span
//                 style={{
//                   fontSize: 11,
//                   color: colors.text,
//                   flex: 1,
//                   minWidth: 0,
//                   overflow: "hidden",
//                   textOverflow: "ellipsis",
//                   whiteSpace: "nowrap",
//                   fontWeight: 600,
//                 }}
//               >
//                 {fullStoreUrl.replace(/^https?:\/\//, "")}
//               </span>
//               <IconBtn onClick={handleCopyStoreUrl} title="Copy URL">
//                 {copiedStoreUrl ? (
//                   <Check size={12} color={colors.success} />
//                 ) : (
//                   <Copy size={12} />
//                 )}
//               </IconBtn>
//               <IconBtn onClick={handleOpenStoreUrl} title="Open in new tab">
//                 <ExternalLink size={12} />
//               </IconBtn>
//               <IconBtn onClick={handleShareStoreUrl} title="Share">
//                 <Share2 size={12} />
//               </IconBtn>
//             </div>
//           )}

//           {!collapsed && shouldShowStoreUrl && (
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 gap: 6,
//                 padding: "0 2px",
//               }}
//             >
//               <span
//                 style={{
//                   fontSize: 10.5,
//                   color: colors.secondaryText,
//                   overflow: "hidden",
//                   textOverflow: "ellipsis",
//                   whiteSpace: "nowrap",
//                   minWidth: 0,
//                 }}
//               >
//                 {displayShopName}
//               </span>
//               {(isAgentStore || isSubAgentStore) && (
//                 <span
//                   style={{
//                     display: "inline-flex",
//                     alignItems: "center",
//                     gap: 4,
//                     fontSize: 9,
//                     padding: "2px 8px",
//                     borderRadius: 10,
//                     background: isAgentStore
//                       ? `${colors.btnBg}18`
//                       : `${colors.linkColor}18`,
//                     color: isAgentStore ? colors.btnBg : colors.linkColor,
//                     fontWeight: 800,
//                     letterSpacing: 0.4,
//                     textTransform: "uppercase",
//                     flexShrink: 0,
//                   }}
//                 >
//                   <span
//                     style={{
//                       width: 5,
//                       height: 5,
//                       borderRadius: "50%",
//                       background: isAgentStore
//                         ? colors.btnBg
//                         : colors.linkColor,
//                     }}
//                   />
//                   {isAgentStore ? "Agent" : "Sub"}
//                 </span>
//               )}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* ── Nav ─────────────────────────────────────────── */}
//       <nav
//         style={{
//           flex: 1,
//           overflowY: "auto",
//           overflowX: "hidden",
//           padding: collapsed
//             ? "8px 6px"
//             : isMobile
//               ? "4px 12px 16px"
//               : "4px 8px 12px",
//           scrollbarWidth: "thin",
//           overscrollBehavior: "contain",
//           WebkitOverflowScrolling: "touch",
//         }}
//       >
//         <SectionLabel>Main</SectionLabel>
//         {navTree.base.map(renderNode)}

//         {navTree.roleNodes.length > 0 && (
//           <>
//             <SectionLabel>
//               {ROLE_SECTION_TITLE[user?.role] || "Quick access"}
//             </SectionLabel>
//             {navTree.roleNodes.map(renderNode)}
//           </>
//         )}
//       </nav>

//       {/* ── Bottom shelf ────────────────────────────────── */}
//       <div
//         style={{
//           padding: collapsed
//             ? "8px 6px"
//             : isMobile
//               ? "12px 12px calc(16px + env(safe-area-inset-bottom, 0px))"
//               : "8px 8px 10px",
//           borderTop: `1px solid ${colors.border}`,
//           display: "flex",
//           flexDirection: "column",
//           gap: 2,
//         }}
//       >
//         {!collapsed && (
//           <button
//             type="button"
//             onClick={() => showToast("Help & Support coming soon", "info")}
//             style={bottomBtnStyle(colors)}
//             onMouseEnter={(e) =>
//               (e.currentTarget.style.background = colors.hoverBg)
//             }
//             onMouseLeave={(e) =>
//               (e.currentTarget.style.background = "transparent")
//             }
//           >
//             <HelpCircle size={15} />
//             <span>Help & Support</span>
//           </button>
//         )}

//         {isAuthenticated ? (
//           <button
//             type="button"
//             onClick={handleLogout}
//             style={{
//               ...bottomBtnStyle(colors),
//               color: colors.error,
//               justifyContent: collapsed ? "center" : "flex-start",
//             }}
//             onMouseEnter={(e) =>
//               (e.currentTarget.style.background = colors.errorBg)
//             }
//             onMouseLeave={(e) =>
//               (e.currentTarget.style.background = "transparent")
//             }
//           >
//             <LogOut size={collapsed ? 18 : 15} />
//             {!collapsed && <span>Sign out</span>}
//           </button>
//         ) : (
//           <button
//             type="button"
//             onClick={() => {
//               navigate("/login");
//               if (isMobile) onClose();
//             }}
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: 8,
//               width: "100%",
//               padding: collapsed ? "10px" : "10px 12px",
//               borderRadius: 9,
//               background: colors.btnBg,
//               color: colors.btnText,
//               border: "none",
//               cursor: "pointer",
//               fontWeight: 700,
//               fontSize: 13,
//               boxShadow: `0 3px 10px ${colors.btnBg}33`,
//             }}
//           >
//             <User size={collapsed ? 18 : 15} />
//             {!collapsed && <span>Sign in</span>}
//           </button>
//         )}

//         {!collapsed && (
//           <div
//             style={{
//               textAlign: "center",
//               fontSize: 10,
//               color: colors.secondaryText,
//               opacity: 0.45,
//               marginTop: 4,
//               letterSpacing: 0.4,
//               fontWeight: 600,
//             }}
//           >
//             Azoemart
//           </div>
//         )}
//       </div>
//     </div>
//   );

//   /* ── Mobile: drawer ──────────────────────────────────── */
//   if (isMobile) {
//     return (
//       <>
//         <div
//           onClick={onClose}
//           aria-hidden={!isOpen}
//           style={{
//             position: "fixed",
//             inset: 0,
//             background: colors.scrim,
//             backdropFilter: "blur(6px)",
//             WebkitBackdropFilter: "blur(6px)",
//             opacity: isOpen ? 1 : 0,
//             pointerEvents: isOpen ? "auto" : "none",
//             transition: "opacity 0.25s ease",
//             zIndex: 999,
//           }}
//         />
//         <aside
//           role="dialog"
//           aria-modal="true"
//           aria-label="Main navigation"
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             bottom: 0,
//             width: "min(340px, 88vw)",
//             background: colors.raisedBg,
//             zIndex: 1000,
//             transform: isOpen ? "translateX(0)" : "translateX(-100%)",
//             transition: "transform 0.32s cubic-bezier(0.22, 1, 0.36, 1)",
//             boxShadow: isOpen ? `0 0 80px ${colors.shadowStrong}` : "none",
//             display: "flex",
//             flexDirection: "column",
//             overflow: "hidden",
//           }}
//         >
//           {content}
//         </aside>
//       </>
//     );
//   }

//   /* ── Desktop: docked ─────────────────────────────────── */
//   return (
//     <aside
//       style={{
//         width: isOpen ? (isCollapsed ? 76 : 268) : 0,
//         overflow: "hidden",
//         transition: "width 0.25s cubic-bezier(0.22, 1, 0.36, 1)",
//         flexShrink: 0,
//         background: colors.raisedBg,
//         borderRight: `1px solid ${colors.border}`,
//         position: "relative",
//       }}
//     >
//       {isOpen && content}
//     </aside>
//   );
// };

// /* ══════════════════════════════════════════════════════════
//    Style helpers
//    ══════════════════════════════════════════════════════════ */

// const styles = {
//   logoTile: (c, isMobile, collapsed) => ({
//     width: isMobile ? 34 : collapsed ? 34 : 30,
//     height: isMobile ? 34 : collapsed ? 34 : 30,
//     borderRadius: 9,
//     background: c.subtleBg || c.hoverBg,
//     border: `1px solid ${c.border}`,
//     display: "inline-flex",
//     alignItems: "center",
//     justifyContent: "center",
//     flexShrink: 0,
//   }),
//   groupChildren: {
//     position: "relative",
//     marginTop: 2,
//     marginBottom: 4,
//   },
//   sectionLabel: {
//     display: "flex",
//     alignItems: "center",
//     gap: 8,
//     padding: "16px 12px 6px",
//     fontSize: 10,
//     fontWeight: 800,
//     textTransform: "uppercase",
//     letterSpacing: 1.2,
//   },
// };

// const iconBtnStyle = (colors) => ({
//   width: 28,
//   height: 28,
//   borderRadius: 7,
//   border: "none",
//   background: "transparent",
//   color: colors.secondaryText,
//   cursor: "pointer",
//   display: "inline-flex",
//   alignItems: "center",
//   justifyContent: "center",
//   transition: "background 0.15s ease, color 0.15s ease",
//   flexShrink: 0,
// });

// const bottomBtnStyle = (colors) => ({
//   display: "flex",
//   alignItems: "center",
//   gap: 10,
//   width: "100%",
//   padding: "8px 10px",
//   borderRadius: 8,
//   background: "transparent",
//   border: "none",
//   color: colors.secondaryText,
//   cursor: "pointer",
//   fontSize: 12.5,
//   fontWeight: 600,
//   transition: "background 0.15s ease",
//   fontFamily: "inherit",
// });

// const IconBtn = ({ onClick, title, children }) => {
//   const { colors } = useTheme();
//   const [hovered, setHovered] = useState(false);
//   return (
//     <button
//       type="button"
//       onClick={(e) => {
//         e.stopPropagation();
//         onClick();
//       }}
//       title={title}
//       onMouseEnter={() => setHovered(true)}
//       onMouseLeave={() => setHovered(false)}
//       style={{
//         padding: 4,
//         borderRadius: 6,
//         border: "none",
//         background: hovered ? colors.hoverBg : "transparent",
//         color: hovered ? colors.text : colors.secondaryText,
//         cursor: "pointer",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         transition: "background 0.15s ease, color 0.15s ease",
//         flexShrink: 0,
//       }}
//     >
//       {children}
//     </button>
//   );
// };

// export default Sidebar;























// components/layout/Sidebar.jsx
import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import {
  LayoutDashboard,
  Package,
  LogOut,
  Wallet,
  User,
  X,
  Home,
  Store,
  TrendingUp,
  Shield,
  ClipboardList,
  UserPlus,
  ChevronRight,
  ChevronLeft,
  ChevronDown,
  Crown,
  Sparkles,
  Bell,
  HelpCircle,
  Copy,
  Share2,
  ExternalLink,
  Check,
  ShoppingBag,
  SlidersHorizontal,
  Layers,
  BadgeCheck,
  Clock,
  Tags,
  CalendarDays,
  ReceiptText,
  GraduationCap,
  BookOpen,
  ArrowUpRight,
} from "lucide-react";
import { useAuth } from "../../providers/AuthProvider";
import { useTheme } from "../../hooks/useTheme";
import { useNavigate, useLocation } from "react-router-dom";
import { useToast } from "../../providers/ToastProvider";
import { useAgentContext } from "../../hooks/useAgentContext";
import azoemartLogo from "../../assets/images/azoemart.png";

const COLLAPSE_KEY = "sidebar_collapsed";
const GROUPS_KEY = "sidebar_groups_open";

/* ══════════════════════════════════════════════════════════
   Route matching
   ══════════════════════════════════════════════════════════ */

const scoreMatch = (candidate, current) => {
  if (!candidate || !current) return 0;
  if (candidate === current) return 1000 + candidate.length;
  if (candidate === "/") return current === "/" ? 1 : 0;
  if (current.startsWith(candidate + "/")) return candidate.length;
  return 0;
};

const collectLeafPaths = (nodes) => {
  const out = [];
  for (const node of nodes) {
    if (node.type === "group") {
      out.push(...collectLeafPaths(node.children || []));
      if (node.defaultPath) out.push(node.defaultPath);
    } else if (node.path) {
      out.push(node.path.split("?")[0]);
    }
  }
  return out;
};

const findBestActivePath = (pathname, leafPaths) => {
  let best = null;
  let bestScore = 0;
  for (const p of leafPaths) {
    const s = scoreMatch(p, pathname);
    if (s > bestScore) {
      best = p;
      bestScore = s;
    }
  }
  return best;
};

/* ══════════════════════════════════════════════════════════
   Utilities
   ══════════════════════════════════════════════════════════ */

const initialsOf = (user) => {
  if (!user) return "?";
  const first = user.first_name?.[0] || "";
  const last = user.last_name?.[0] || "";
  if (first || last) return (first + last).toUpperCase();
  const src = user.username || user.phone_number || "?";
  return src.slice(0, 2).toUpperCase();
};

const ROLE_META = {
  ADMIN: { label: "Admin", icon: Shield, tone: "error" },
  AGENT: { label: "Agent", icon: Crown, tone: "warning" },
  SUB_AGENT: { label: "Sub-agent", icon: Sparkles, tone: "link" },
  CUSTOMER: { label: "Customer", icon: User, tone: "success" },
};

const ROLE_SECTION_TITLE = {
  ADMIN: "Admin tools",
  AGENT: "Agent tools",
  SUB_AGENT: "Sub-agent tools",
  CUSTOMER: "Get started",
};

const readOpenGroups = () => {
  try {
    const raw = localStorage.getItem(GROUPS_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

const writeOpenGroups = (map) => {
  try {
    localStorage.setItem(GROUPS_KEY, JSON.stringify(map));
  } catch {}
};

const roleToneColor = (colors, tone) => {
  const map = {
    warning: colors.warning,
    error: colors.error,
    link: colors.linkColor,
    success: colors.success,
  };
  return map[tone] || colors.secondaryText;
};

/* Normalize a store URL slug for comparison — strip protocol, trailing slash, lowercase */
const normalizeSlug = (v) => {
  if (!v) return null;
  return String(v)
    .replace(/^https?:\/\//, "")
    .replace(/\.azoeshop\.store\/?$/, "")
    .replace(/\/$/, "")
    .trim()
    .toLowerCase();
};

/* ══════════════════════════════════════════════════════════
   Sidebar
   ══════════════════════════════════════════════════════════ */

const Sidebar = ({ isOpen, isMobile, onClose }) => {
  const { user, logout, isAuthenticated, authFetch } = useAuth();
  const { colors } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const { showToast } = useToast();
  const { agent } = useAgentContext();

  const [isSubAgentOfThisAgent, setIsSubAgentOfThisAgent] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isCollapsed, setIsCollapsed] = useState(() => {
    try {
      return localStorage.getItem(COLLAPSE_KEY) === "1";
    } catch {
      return false;
    }
  });
  const [openGroups, setOpenGroups] = useState(readOpenGroups);
  const [hoveredPath, setHoveredPath] = useState(null);
  const [copiedStoreUrl, setCopiedStoreUrl] = useState(false);
  const hasFetched = useRef(false);

  useEffect(() => {
    try {
      localStorage.setItem(COLLAPSE_KEY, isCollapsed ? "1" : "0");
    } catch {}
  }, [isCollapsed]);

  useEffect(() => {
    writeOpenGroups(openGroups);
  }, [openGroups]);

  const collapsed = isMobile ? false : isCollapsed;

  /* ── Store context (the CURRENT subdomain) ───────────── */
  const storeContext = useMemo(
    () =>
      agent
        ? {
            type: agent.agent?.role === "AGENT" ? "agent" : "subagent",
            id: agent.agent?.id,
            userId:
              agent.agent?.user_id ||
              agent.agent?.user?.id ||
              null,
            storeUrl:
              agent.profile?.store_url ||
              agent.agent?.store_url ||
              null,
            shopName:
              agent.profile?.shop_name ||
              agent.agent?.shop_name ||
              null,
            role: agent.agent?.role,
          }
        : null,
    [agent]
  );

  /* ── The VISITOR's own store URL (regardless of location) ── */
  const ownStoreUrl =
    user?.sub_agent_profile?.store_url ||
    user?.agent_profile?.sub_agent_store_url ||
    user?.agent_profile?.store_url ||
    user?.store_url ||
    (user?.role === "AGENT" ? user?.username : null);

  const fullOwnStoreUrl = useMemo(() => {
    if (!ownStoreUrl) return null;
    const clean = normalizeSlug(ownStoreUrl);
    return clean ? `https://${clean}.azoeshop.store` : null;
  }, [ownStoreUrl]);

  /* ── The CURRENT store URL (fallback for anonymous visitors) ── */
  const fullCurrentStoreUrl = useMemo(() => {
    if (!storeContext?.storeUrl) return null;
    const clean = normalizeSlug(storeContext.storeUrl);
    return clean ? `https://${clean}.azoeshop.store` : null;
  }, [storeContext]);

  const displayShopName =
    storeContext?.shopName ||
    user?.agent_profile?.shop_name ||
    user?.username ||
    "My Store";

  const isAgentStore = storeContext?.role === "AGENT" || user?.role === "AGENT";
  const isSubAgentStore =
    storeContext?.role === "SUB_AGENT" || user?.role === "SUB_AGENT";

  /* ── Sub-agent-of-this-agent probe ───────────────────── */
  useEffect(() => {
    if (
      isAuthenticated &&
      storeContext?.type === "agent" &&
      user?.role !== "AGENT" &&
      !hasFetched.current
    ) {
      hasFetched.current = true;
      setIsLoading(true);
      authFetch(`/accounts/agents/${storeContext.id}/sub-agents/`)
        .then((r) => r.json())
        .then((data) => {
          if (data.status === "success") {
            const subs = data.data?.sub_agents || [];
            setIsSubAgentOfThisAgent(
              subs.some((sa) => sa.user_id === user.id)
            );
          }
        })
        .catch((e) => console.error("sub-agent check:", e))
        .finally(() => setIsLoading(false));
    } else {
      setIsLoading(false);
      if (
        !isAuthenticated ||
        storeContext?.type !== "agent" ||
        user?.role === "AGENT"
      ) {
        hasFetched.current = false;
      }
    }
  }, [isAuthenticated, storeContext, user?.role, user?.id, authFetch]);

  /* ── Context gating ───────────────────────────────────── */
  const onMainSite = !storeContext;

  /*
   * Ownership detection — three independent checks, any of which
   * establishes that the current storefront belongs to the visitor.
   *
   *  (a) UUID match: user.agent_profile.id === storeContext.id
   *      (works when the serializer exposes the agent profile UUID).
   *  (b) UUID match via storeContext.userId:
   *      user.id === storeContext.userId
   *      (works when agent-by-store returns the owner's user id).
   *  (c) Slug match: the visitor's own store URL slug equals the
   *      current store URL slug. This is the most robust check
   *      because it uses two strings that are guaranteed present —
   *      no UUID field naming guesses required.
   */
  const ownAgentProfileId = user?.agent_profile?.id || null;
  const ownStoreSlug = normalizeSlug(ownStoreUrl);
  const currentStoreSlug = normalizeSlug(storeContext?.storeUrl);

  const isOwnerByProfileId =
    !!ownAgentProfileId &&
    !!storeContext?.id &&
    ownAgentProfileId === storeContext.id;

  const isOwnerByUserId =
    !!user?.id &&
    !!storeContext?.userId &&
    user.id === storeContext.userId;

  const isOwnerBySlug =
    !!ownStoreSlug &&
    !!currentStoreSlug &&
    ownStoreSlug === currentStoreSlug;

  const ownsCurrentStore =
    storeContext?.type === "agent" &&
    isAuthenticated &&
    (user?.role === "AGENT" || user?.role === "SUB_AGENT") &&
    (isOwnerByProfileId || isOwnerByUserId || isOwnerBySlug);

  // Context is resolved once we know whether we're on a store and — if
  // we are — whether the visitor owns it or is a sub-agent of it.
  const contextReady =
    !storeContext ||
    !isAuthenticated ||
    user?.role === "ADMIN" ||
    isLoading === false;

  // Role tools visible ONLY:
  //   - for admins (anywhere),
  //   - on the visitor's OWN storefront,
  //   - on a storefront they are a sub-agent of,
  //   - for customers on the main site (the "Become Agent" CTA).
  const canUseRoleTools =
    contextReady &&
    (
      user?.role === "ADMIN" ||
      ownsCurrentStore ||
      (storeContext?.type === "agent" && isSubAgentOfThisAgent) ||
      (user?.role === "CUSTOMER" && onMainSite)
    );

  /* ── Derived display helpers ──────────────────────────── */
  const roleMeta = ROLE_META[user?.role] || null;

  /* The URL to show in the sidebar tile: always the visitor's own
     store when they have one, else the current site's store. */
  const tileStoreUrl = fullOwnStoreUrl || fullCurrentStoreUrl;
  const shouldShowStoreUrl = !!tileStoreUrl;

  /* Whether to show the "not on your store" hint. */
  const roleNeedsOwnStore =
    isAuthenticated &&
    (user?.role === "AGENT" || user?.role === "SUB_AGENT");

  const showGoToStoreHint =
    roleNeedsOwnStore &&
    !!fullOwnStoreUrl &&
    !canUseRoleTools;

  /* ── Handlers ─────────────────────────────────────────── */
  const handleLogout = useCallback(async () => {
    try {
      await logout();
      showToast("Logged out successfully", "success");
      navigate("/login");
    } catch {
      showToast("Logout failed", "error");
    }
  }, [logout, navigate, showToast]);

  const handleCopyStoreUrl = useCallback(async () => {
    if (!tileStoreUrl) return;
    try {
      await navigator.clipboard.writeText(tileStoreUrl);
      setCopiedStoreUrl(true);
      showToast("Store URL copied", "success");
      setTimeout(() => setCopiedStoreUrl(false), 2000);
    } catch {
      showToast("Failed to copy URL", "error");
    }
  }, [tileStoreUrl, showToast]);

  const handleOpenStoreUrl = useCallback(() => {
    if (tileStoreUrl) window.open(tileStoreUrl, "_blank");
  }, [tileStoreUrl]);

  const handleShareStoreUrl = useCallback(async () => {
    if (!tileStoreUrl) return;
    if (navigator.share) {
      try {
        await navigator.share({
          title: `${displayShopName} - Azoemart`,
          text: `Check out ${displayShopName} on Azoemart!`,
          url: tileStoreUrl,
        });
        return;
      } catch (e) {
        if (e.name === "AbortError") return;
      }
    }
    handleCopyStoreUrl();
  }, [tileStoreUrl, displayShopName, handleCopyStoreUrl]);

  const handleGoToMyStore = useCallback(() => {
    if (fullOwnStoreUrl) {
      window.open(fullOwnStoreUrl, "_blank", "noopener");
    }
  }, [fullOwnStoreUrl]);

  /* ══════════════════════════════════════════════════════
     Navigation tree
     ══════════════════════════════════════════════════════ */

  const customerMarketplaceGroup = useMemo(
    () => ({
      type: "group",
      id: "marketplace",
      icon: Store,
      label: "Marketplace",
      defaultPath: "/marketplace",
      children: [
        {
          path: "/marketplace",
          icon: Layers,
          label: "Shop",
          exact: true,
        },
        {
          path: "/dropshipping",
          icon: TrendingUp,
          label: "Ready to ship",
        },
        {
          path: "/marketplace?filter=ghana",
          icon: BadgeCheck,
          label: "Available in Ghana",
          matchQuery: { filter: "ghana" },
        },
        {
          path: "/preorder",
          icon: Clock,
          label: "Pre-order windows",
        },
      ],
    }),
    []
  );

  const buildAdminMarketplaceGroup = (role) => {
    const isAdmin = role === "ADMIN";

    const children = [
      {
        path: "/marketplace/manage",
        icon: LayoutDashboard,
        label: "Overview",
        exact: true,
      },
    ];

    if (isAdmin) {
      children.push(
        { path: "/marketplace/manage/categories", icon: Tags, label: "Categories" },
        { path: "/marketplace/manage/products", icon: Package, label: "Products" },
        { path: "/marketplace/manage/campaigns", icon: CalendarDays, label: "Campaigns" }
      );
    }

    children.push(
      { path: "/marketplace/manage/pricing", icon: SlidersHorizontal, label: "Pricing" },
      { path: "/marketplace/manage/orders", icon: ReceiptText, label: "Orders" }
    );

    return {
      type: "group",
      id: "marketplace-admin",
      icon: Store,
      label: "Marketplace admin",
      defaultPath: "/marketplace/manage",
      children,
    };
  };

  const buildCoursesGroup = (role) => {
    const isAdmin = role === "ADMIN";
    const children = [];

    if (isAdmin) {
      children.push(
        { path: "/courses/manage/catalog", icon: BookOpen, label: "Catalog" },
        { path: "/courses/manage/enrollments", icon: ReceiptText, label: "Enrollments" }
      );
    }
    children.push({
      path: "/courses/manage/pricing",
      icon: SlidersHorizontal,
      label: "Pricing",
    });

    return {
      type: "group",
      id: "courses-admin",
      icon: GraduationCap,
      label: "Courses",
      defaultPath: "/courses/manage",
      children,
    };
  };

  /* ── Build link tree by role ─────────────────────────── */
  const navTree = useMemo(() => {
    const base = [
      { type: "link", path: "/", icon: Home, label: "Home" },
      { type: "link", path: "/data", icon: TrendingUp, label: "Data Services" },
      customerMarketplaceGroup,
      { type: "link", path: "/orders", icon: ClipboardList, label: "Data Orders" },
      {
        type: "link",
        path: "/marketplace/orders",
        icon: ShoppingBag,
        label: "Marketplace Orders",
      },
      { type: "link", path: "/notices", icon: Bell, label: "Notices" },
    ];

    const showSubAgent =
      (storeContext?.type === "agent" && !isAuthenticated) ||
      (storeContext?.type === "agent" &&
        isAuthenticated &&
        !isSubAgentOfThisAgent &&
        user?.role !== "AGENT" &&
        !isLoading);

    if (showSubAgent) {
      base.push({
        type: "link",
        path: "/subagent/register",
        icon: UserPlus,
        label: "Become Sub-Agent",
        isSpecial: true,
      });
    }

    const roleNodes = [];
    if (canUseRoleTools) {
      switch (user?.role) {
        case "CUSTOMER":
          roleNodes.push({
            type: "link",
            path: "/become-agent",
            icon: UserPlus,
            label: "Become Agent",
            isSpecial: true,
          });
          break;
        case "ADMIN":
          roleNodes.push(
            { type: "link", path: "/admin/dashboard", icon: LayoutDashboard, label: "Dashboard" },
            { type: "link", path: "/admin/users", icon: User, label: "Manage Users" },
            { type: "link", path: "/admin/data-packages", icon: Package, label: "Data Packages" },
            buildAdminMarketplaceGroup(user.role),
            buildCoursesGroup(user.role),
            { type: "link", path: "/admin/withdrawals", icon: Wallet, label: "Withdrawals" },
            { type: "link", path: "/admin/notices", icon: Bell, label: "Manage Notices" }
          );
          break;
        case "AGENT":
          roleNodes.push(
            { type: "link", path: "/agent/dashboard", icon: LayoutDashboard, label: "Dashboard" },
            buildAdminMarketplaceGroup(user.role),
            buildCoursesGroup(user.role),
            { type: "link", path: "/agent/subagents", icon: User, label: "Sub Agents" },
            { type: "link", path: "/agent/withdrawals", icon: Wallet, label: "Withdrawals" }
          );
          break;
        case "SUB_AGENT":
          roleNodes.push(
            { type: "link", path: "/subagent/dashboard", icon: LayoutDashboard, label: "Dashboard" },
            buildAdminMarketplaceGroup(user.role),
            buildCoursesGroup(user.role),
            { type: "link", path: "/subagent/withdrawals", icon: Wallet, label: "Withdrawals" }
          );
          break;
        default:
          break;
      }
    }

    // Unpaid agents: hide write-only nav items so they don't hit 403.
    if (user?.is_unpaid_agent) {
      const WRITE_PATHS = new Set([
        "/agent/withdrawals",
        "/subagent/withdrawals",
        "/admin/withdrawals",
        "/agent/subagents",
        "/subagent/register",
      ]);
      const prune = (nodes) =>
        nodes
          .filter((n) => !WRITE_PATHS.has(n.path))
          .map((n) =>
            n.type === "group"
              ? { ...n, children: prune(n.children || []) }
              : n
          );
      roleNodes.splice(0, roleNodes.length, ...prune(roleNodes));
    }

    return { base, roleNodes };
  }, [
    user?.role,
    user?.agent_profile?.id,
    user?.is_unpaid_agent,
    storeContext,
    isAuthenticated,
    isSubAgentOfThisAgent,
    isLoading,
    customerMarketplaceGroup,
    onMainSite,
    contextReady,
    canUseRoleTools,
    ownsCurrentStore,
  ]);

  /* ══════════════════════════════════════════════════════
     Active leaf resolution
     ══════════════════════════════════════════════════════ */

  const allLeafPaths = useMemo(() => {
    const all = [...navTree.base, ...navTree.roleNodes];
    return collectLeafPaths(all);
  }, [navTree]);

  const bestActivePath = useMemo(
    () => findBestActivePath(location.pathname, allLeafPaths),
    [location.pathname, allLeafPaths]
  );

  const activeGroups = useMemo(() => {
    const set = new Set();
    const visit = (nodes) => {
      for (const node of nodes) {
        if (node.type === "group") {
          const children = node.children || [];
          const hasActiveChild =
            children.some(
              (c) =>
                scoreMatch(c.path.split("?")[0], location.pathname) > 0 &&
                c.path.split("?")[0] === bestActivePath
            ) || node.defaultPath === bestActivePath;
          if (hasActiveChild) set.add(node.id);
          visit(children);
        }
      }
    };
    visit(navTree.base);
    visit(navTree.roleNodes);
    return set;
  }, [navTree, bestActivePath, location.pathname]);

  useEffect(() => {
    if (activeGroups.size === 0) return;
    setOpenGroups((prev) => {
      let changed = false;
      const next = { ...prev };
      activeGroups.forEach((id) => {
        if (!next[id]) {
          next[id] = true;
          changed = true;
        }
      });
      return changed ? next : prev;
    });
  }, [activeGroups]);

  const toggleGroup = (id) =>
    setOpenGroups((prev) => ({ ...prev, [id]: !prev[id] }));

  /* ══════════════════════════════════════════════════════
     Rendering helpers
     ══════════════════════════════════════════════════════ */

  const currentParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  const isLeafActive = useCallback(
    (leaf) => {
      if (leaf.matchQuery) {
        if (scoreMatch(leaf.path.split("?")[0], location.pathname) === 0)
          return false;
        return Object.entries(leaf.matchQuery).every(
          ([k, v]) => currentParams.get(k) === v
        );
      }
      if (leaf.exact) {
        return scoreMatch(leaf.path, location.pathname) >= 1000;
      }
      return leaf.path === bestActivePath;
    },
    [location.pathname, currentParams, bestActivePath]
  );

  /* ── Sub-components ───────────────────────────────────── */

  const LeafItem = ({ leaf, isChild = false }) => {
    const Icon = leaf.icon;
    const active = isLeafActive(leaf);
    const hovered = hoveredPath === leaf.path;

    const handleClick = (e) => {
      if (leaf.external) {
        e.preventDefault();
        window.open(leaf.path, "_blank", "noopener");
        return;
      }
      navigate(leaf.path);
      if (isMobile) onClose();
    };

    return (
      <button
        type="button"
        onClick={handleClick}
        onMouseEnter={() => setHoveredPath(leaf.path)}
        onMouseLeave={() => setHoveredPath(null)}
        style={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: collapsed ? "center" : "flex-start",
          gap: collapsed ? 0 : 12,
          width: "100%",
          padding: collapsed
            ? "10px"
            : isChild
            ? "8px 12px 8px 34px"
            : isMobile
            ? "11px 12px"
            : "9px 12px",
          borderRadius: 8,
          background: active
            ? colors.activeBg
            : hovered
            ? colors.hoverBg
            : "transparent",
          color: active
            ? colors.btnBg
            : leaf.isSpecial
            ? colors.btnBg
            : colors.text,
          border: "1px solid transparent",
          cursor: "pointer",
          transition: "background 0.14s ease, color 0.14s ease",
          marginBottom: 2,
          fontWeight: active ? 700 : 500,
          fontSize: isChild ? (isMobile ? 13.5 : 12.5) : isMobile ? 14 : 13.5,
          fontFamily: "inherit",
        }}
      >
        {active && !isChild && (
          <span
            style={{
              position: "absolute",
              left: collapsed ? "50%" : 0,
              transform: collapsed
                ? "translate(-50%, -50%)"
                : "translateY(-50%)",
              top: collapsed ? "auto" : "50%",
              bottom: collapsed ? 4 : "auto",
              width: collapsed ? 16 : 3,
              height: collapsed ? 3 : 20,
              borderRadius: 2,
              background: colors.btnBg,
            }}
          />
        )}

        <Icon
          size={collapsed ? 20 : isChild ? 14 : isMobile ? 18 : 16}
          strokeWidth={active ? 2.4 : isChild ? 1.9 : 2}
          style={{ flexShrink: 0 }}
        />

        {!collapsed && (
          <>
            <span
              style={{
                flex: 1,
                textAlign: "left",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {leaf.label}
            </span>
            {leaf.isSpecial && (
              <span
                style={{
                  fontSize: 9,
                  fontWeight: 800,
                  padding: "2px 7px",
                  borderRadius: 8,
                  background: colors.btnBg,
                  color: colors.btnText,
                  letterSpacing: 0.4,
                  textTransform: "uppercase",
                }}
              >
                New
              </span>
            )}
          </>
        )}
      </button>
    );
  };

  const GroupItem = ({ group }) => {
    const Icon = group.icon;
    const open = !!openGroups[group.id];
    const containsActive = activeGroups.has(group.id);
    const hovered = hoveredPath === `group-${group.id}`;

    const handleClick = () => {
      if (collapsed) {
        const target = group.defaultPath || group.children?.[0]?.path;
        if (target) {
          navigate(target);
          if (isMobile) onClose();
        }
        return;
      }
      toggleGroup(group.id);
    };

    return (
      <div style={{ marginBottom: 2, position: "relative" }}>
        <button
          type="button"
          onClick={handleClick}
          onMouseEnter={() => setHoveredPath(`group-${group.id}`)}
          onMouseLeave={() => setHoveredPath(null)}
          aria-expanded={collapsed ? undefined : open}
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: collapsed ? "center" : "flex-start",
            gap: collapsed ? 0 : 12,
            width: "100%",
            padding: collapsed
              ? "10px"
              : isMobile
              ? "11px 12px"
              : "9px 12px",
            borderRadius: 8,
            background: containsActive
              ? colors.activeBg
              : hovered
              ? colors.hoverBg
              : "transparent",
            color: containsActive ? colors.btnBg : colors.text,
            border: "1px solid transparent",
            cursor: "pointer",
            transition: "background 0.14s ease, color 0.14s ease",
            fontWeight: containsActive ? 700 : 500,
            fontSize: isMobile ? 14 : 13.5,
            fontFamily: "inherit",
          }}
        >
          {containsActive && !collapsed && (
            <span
              style={{
                position: "absolute",
                left: 0,
                top: "50%",
                transform: "translateY(-50%)",
                width: 3,
                height: 20,
                borderRadius: 2,
                background: colors.btnBg,
              }}
            />
          )}

          <Icon
            size={collapsed ? 20 : isMobile ? 18 : 16}
            strokeWidth={containsActive ? 2.4 : 2}
            style={{ flexShrink: 0 }}
          />

          {!collapsed && (
            <>
              <span
                style={{
                  flex: 1,
                  textAlign: "left",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {group.label}
              </span>
              <ChevronDown
                size={14}
                style={{
                  color: containsActive
                    ? colors.btnBg
                    : colors.secondaryText,
                  transition: "transform 0.22s ease, color 0.14s ease",
                  transform: open ? "rotate(0deg)" : "rotate(-90deg)",
                  flexShrink: 0,
                }}
              />
            </>
          )}
        </button>

        {!collapsed && open && (
          <div style={styles.groupChildren}>
            <span
              style={{
                position: "absolute",
                left: 20,
                top: 4,
                bottom: 4,
                width: 1,
                borderLeft: `1px dashed ${colors.separator || colors.border}`,
                opacity: 0.7,
                pointerEvents: "none",
              }}
            />
            {group.children.map((leaf) => (
              <LeafItem key={leaf.path} leaf={leaf} isChild />
            ))}
          </div>
        )}

        {collapsed && hovered && (
          <Tooltip colors={colors}>{group.label}</Tooltip>
        )}
      </div>
    );
  };

  const Tooltip = ({ children, colors }) => (
    <div
      style={{
        position: "absolute",
        left: "calc(100% + 10px)",
        top: "50%",
        transform: "translateY(-50%)",
        background: colors.heading,
        color: colors.mainBg,
        padding: "6px 12px",
        borderRadius: 8,
        fontSize: 12.5,
        fontWeight: 600,
        whiteSpace: "nowrap",
        zIndex: 100,
        pointerEvents: "none",
        boxShadow: `0 6px 16px ${colors.shadowStrong}`,
      }}
    >
      <span
        style={{
          position: "absolute",
          left: -4,
          top: "50%",
          transform: "translateY(-50%) rotate(45deg)",
          width: 8,
          height: 8,
          background: colors.heading,
          borderRadius: 1,
        }}
      />
      {children}
    </div>
  );

  const SectionLabel = ({ children }) =>
    collapsed ? null : (
      <div style={styles.sectionLabel}>
        <span style={{ color: colors.secondaryText }}>{children}</span>
        <span
          style={{
            flex: 1,
            height: 1,
            background: colors.separator || colors.border,
            opacity: 0.5,
          }}
        />
      </div>
    );

  const renderNode = (node) => {
    if (node.type === "group") {
      return <GroupItem key={node.id} group={node} />;
    }
    return <LeafItem key={node.path} leaf={node} />;
  };

  /* ══════════════════════════════════════════════════════
     Content
     ══════════════════════════════════════════════════════ */
  const content = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        backgroundColor: colors.raisedBg,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* ── Brand bar ───────────────────────────────────── */}
      <div
        style={{
          padding: collapsed
            ? "10px 12px"
            : isMobile
            ? "12px 16px"
            : "10px 16px",
          borderBottom: `1px solid ${colors.border}`,
          display: "flex",
          alignItems: "center",
          justifyContent: collapsed ? "center" : "space-between",
          gap: 10,
          minHeight: isMobile ? 64 : 60,
        }}
      >
        <button
          type="button"
          onClick={() => {
            navigate("/");
            if (isMobile) onClose();
          }}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            minWidth: 0,
            cursor: "pointer",
            background: "transparent",
            border: "none",
            padding: 0,
            fontFamily: "inherit",
          }}
        >
          <span style={styles.logoTile(colors, isMobile, collapsed)}>
            <img
              src={azoemartLogo}
              alt=""
              style={{
                width: isMobile ? 26 : collapsed ? 26 : 22,
                height: isMobile ? 26 : collapsed ? 26 : 22,
                objectFit: "contain",
              }}
            />
          </span>
          {!collapsed && (
            <span
              style={{
                fontSize: isMobile ? 15.5 : 14.5,
                fontWeight: 800,
                color: colors.heading,
                letterSpacing: -0.3,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              Azoemart
            </span>
          )}
        </button>

        {!isMobile && !collapsed && (
          <button
            type="button"
            onClick={() => setIsCollapsed(true)}
            aria-label="Collapse sidebar"
            style={iconBtnStyle(colors)}
          >
            <ChevronLeft size={15} />
          </button>
        )}

        {!isMobile && collapsed && (
          <button
            type="button"
            onClick={() => setIsCollapsed(false)}
            aria-label="Expand sidebar"
            style={{
              ...iconBtnStyle(colors),
              position: "absolute",
              top: 16,
              right: 8,
            }}
          >
            <ChevronRight size={15} />
          </button>
        )}

        {isMobile && (
          <button
            type="button"
            onClick={onClose}
            aria-label="Close menu"
            style={{
              ...iconBtnStyle(colors),
              width: 36,
              height: 36,
              borderRadius: 9,
              background: colors.subtleBg || colors.hoverBg,
              border: `1px solid ${colors.border}`,
              color: colors.text,
            }}
          >
            <X size={17} />
          </button>
        )}
      </div>

      {/* ── Identity card ───────────────────────────────── */}
      <div
        style={{
          padding: collapsed ? "10px 8px" : "12px 12px",
          borderBottom: `1px solid ${colors.border}`,
        }}
      >
        <div
          style={{
            background: colors.subtleBg || colors.hoverBg,
            border: `1px solid ${colors.border}`,
            borderRadius: 12,
            padding: collapsed ? 8 : isMobile ? 12 : 10,
            display: "flex",
            flexDirection: "column",
            gap: collapsed ? 0 : 10,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: collapsed ? 0 : 10,
              justifyContent: collapsed ? "center" : "flex-start",
              minWidth: 0,
            }}
          >
            <div
              style={{
                position: "relative",
                width: collapsed ? 34 : isMobile ? 42 : 38,
                height: collapsed ? 34 : isMobile ? 42 : 38,
                borderRadius: 10,
                background: `linear-gradient(135deg, ${colors.btnBg}, ${colors.btnBg}aa)`,
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                fontSize: isMobile ? 13 : 12,
                fontWeight: 800,
                letterSpacing: 0.5,
              }}
            >
              {isAuthenticated ? initialsOf(user) : <User size={16} />}
            </div>

            {!collapsed && (
              <div style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    fontSize: isMobile ? 14 : 13.5,
                    fontWeight: 800,
                    color: colors.heading,
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  <span
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: 0,
                    }}
                  >
                    {isAuthenticated
                      ? user?.full_name ||
                        user?.username ||
                        user?.phone_number ||
                        "User"
                      : "Guest"}
                  </span>
                  {roleMeta && (
                    <roleMeta.icon
                      size={13}
                      color={roleToneColor(colors, roleMeta.tone)}
                      style={{ flexShrink: 0 }}
                    />
                  )}
                </div>
                <div
                  style={{
                    fontSize: 11.5,
                    color: colors.secondaryText,
                    marginTop: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                  }}
                >
                  <Shield size={10} />
                  {isAuthenticated
                    ? roleMeta?.label || user?.role?.toLowerCase() || "User"
                    : "Not signed in"}
                </div>
              </div>
            )}
          </div>

          {!collapsed && user?.is_unpaid_agent && (
            <button
              type="button"
              onClick={() => {
                navigate("/register/payment");
                if (isMobile) onClose();
              }}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                width: "100%",
                padding: "6px 8px",
                borderRadius: 8,
                background: colors.warningBg || "#FEF3C7",
                border: `1px solid ${colors.warning || "#F59E0B"}`,
                color: colors.warning || "#F59E0B",
                fontSize: 11,
                fontWeight: 700,
                cursor: "pointer",
                fontFamily: "inherit",
              }}
            >
              <Clock size={12} />
              <span style={{ flex: 1, textAlign: "left" }}>
                Registration payment pending
              </span>
              <ChevronRight size={12} />
            </button>
          )}

          {!collapsed && shouldShowStoreUrl && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                padding: "6px 8px",
                background: colors.raisedBg,
                borderRadius: 8,
                border: `1px solid ${colors.border}`,
              }}
            >
              <Store
                size={12}
                style={{ color: colors.btnBg, flexShrink: 0 }}
              />
              <span
                style={{
                  fontSize: 11,
                  color: colors.text,
                  flex: 1,
                  minWidth: 0,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  fontWeight: 600,
                }}
              >
                {tileStoreUrl.replace(/^https?:\/\//, "")}
              </span>
              <IconBtn onClick={handleCopyStoreUrl} title="Copy URL">
                {copiedStoreUrl ? (
                  <Check size={12} color={colors.success} />
                ) : (
                  <Copy size={12} />
                )}
              </IconBtn>
              <IconBtn onClick={handleOpenStoreUrl} title="Open in new tab">
                <ExternalLink size={12} />
              </IconBtn>
              <IconBtn onClick={handleShareStoreUrl} title="Share">
                <Share2 size={12} />
              </IconBtn>
            </div>
          )}

          {!collapsed && shouldShowStoreUrl && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 6,
                padding: "0 2px",
              }}
            >
              <span
                style={{
                  fontSize: 10.5,
                  color: colors.secondaryText,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  minWidth: 0,
                }}
              >
                {displayShopName}
              </span>
              {(isAgentStore || isSubAgentStore) && (
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 4,
                    fontSize: 9,
                    padding: "2px 8px",
                    borderRadius: 10,
                    background: isAgentStore
                      ? `${colors.btnBg}18`
                      : `${colors.linkColor}18`,
                    color: isAgentStore ? colors.btnBg : colors.linkColor,
                    fontWeight: 800,
                    letterSpacing: 0.4,
                    textTransform: "uppercase",
                    flexShrink: 0,
                  }}
                >
                  <span
                    style={{
                      width: 5,
                      height: 5,
                      borderRadius: "50%",
                      background: isAgentStore
                        ? colors.btnBg
                        : colors.linkColor,
                    }}
                  />
                  {isAgentStore ? "Agent" : "Sub"}
                </span>
              )}
            </div>
          )}
        </div>
      </div>

      {/* ── Nav ─────────────────────────────────────────── */}
      <nav
        style={{
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          padding: collapsed
            ? "8px 6px"
            : isMobile
            ? "4px 12px 16px"
            : "4px 8px 12px",
          scrollbarWidth: "thin",
          overscrollBehavior: "contain",
          WebkitOverflowScrolling: "touch",
        }}
      >
        <SectionLabel>Main</SectionLabel>
        {navTree.base.map(renderNode)}

        {navTree.roleNodes.length > 0 && (
          <>
            <SectionLabel>
              {ROLE_SECTION_TITLE[user?.role] || "Quick access"}
            </SectionLabel>
            {navTree.roleNodes.map(renderNode)}
          </>
        )}

        {/* "Not on your store" hint — for agents/sub-agents on the main
            site or another agent's storefront. */}
        {!collapsed && showGoToStoreHint && (
          <div
            style={{
              marginTop: 14,
              padding: "10px 12px",
              borderRadius: 10,
              background: colors.warningBg || "#FEF3C7",
              border: `1px solid ${colors.warning || "#F59E0B"}66`,
              display: "flex",
              flexDirection: "column",
              gap: 8,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                fontSize: 11,
                fontWeight: 800,
                letterSpacing: 0.3,
                textTransform: "uppercase",
                color: colors.warning || "#F59E0B",
              }}
            >
              <Store size={12} />
              {onMainSite
                ? "Not on your store"
                : "You're on someone else's store"}
            </div>
            <div
              style={{
                fontSize: 12,
                lineHeight: 1.5,
                color: colors.text,
              }}
            >
              {user?.role === "SUB_AGENT"
                ? "To manage your sub-agent store, visit your own store URL."
                : "To manage your store and prices, visit your own store URL."}
            </div>
            <button
              type="button"
              onClick={handleGoToMyStore}
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 6,
                padding: "8px 10px",
                borderRadius: 8,
                border: "none",
                background: colors.warning || "#F59E0B",
                color: "#fff",
                fontSize: 12,
                fontWeight: 700,
                cursor: "pointer",
                fontFamily: "inherit",
              }}
            >
              Go to my store
              <ArrowUpRight size={13} />
            </button>
          </div>
        )}

        {collapsed && showGoToStoreHint && (
          <button
            type="button"
            onClick={handleGoToMyStore}
            title="Go to my store"
            style={{
              marginTop: 10,
              width: "100%",
              padding: "10px",
              borderRadius: 8,
              background: colors.warningBg || "#FEF3C7",
              border: `1px solid ${colors.warning || "#F59E0B"}66`,
              color: colors.warning || "#F59E0B",
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              fontFamily: "inherit",
            }}
          >
            <Store size={16} />
          </button>
        )}
      </nav>

      {/* ── Bottom shelf ────────────────────────────────── */}
      <div
        style={{
          padding: collapsed
            ? "8px 6px"
            : isMobile
            ? "12px 12px calc(16px + env(safe-area-inset-bottom, 0px))"
            : "8px 8px 10px",
          borderTop: `1px solid ${colors.border}`,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        {!collapsed && (
          <button
            type="button"
            onClick={() => showToast("Help & Support coming soon", "info")}
            style={bottomBtnStyle(colors)}
            onMouseEnter={(e) =>
              (e.currentTarget.style.background = colors.hoverBg)
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "transparent")
            }
          >
            <HelpCircle size={15} />
            <span>Help & Support</span>
          </button>
        )}

        {isAuthenticated ? (
          <button
            type="button"
            onClick={handleLogout}
            style={{
              ...bottomBtnStyle(colors),
              color: colors.error,
              justifyContent: collapsed ? "center" : "flex-start",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.background = colors.errorBg)
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "transparent")
            }
          >
            <LogOut size={collapsed ? 18 : 15} />
            {!collapsed && <span>Sign out</span>}
          </button>
        ) : (
          <button
            type="button"
            onClick={() => {
              navigate("/login");
              if (isMobile) onClose();
            }}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
              width: "100%",
              padding: collapsed ? "10px" : "10px 12px",
              borderRadius: 9,
              background: colors.btnBg,
              color: colors.btnText,
              border: "none",
              cursor: "pointer",
              fontWeight: 700,
              fontSize: 13,
              boxShadow: `0 3px 10px ${colors.btnBg}33`,
            }}
          >
            <User size={collapsed ? 18 : 15} />
            {!collapsed && <span>Sign in</span>}
          </button>
        )}

        {!collapsed && (
          <div
            style={{
              textAlign: "center",
              fontSize: 10,
              color: colors.secondaryText,
              opacity: 0.45,
              marginTop: 4,
              letterSpacing: 0.4,
              fontWeight: 600,
            }}
          >
            Azoemart
          </div>
        )}
      </div>
    </div>
  );

  /* ── Mobile: drawer ──────────────────────────────────── */
  if (isMobile) {
    return (
      <>
        <div
          onClick={onClose}
          aria-hidden={!isOpen}
          style={{
            position: "fixed",
            inset: 0,
            background: colors.scrim,
            backdropFilter: "blur(6px)",
            WebkitBackdropFilter: "blur(6px)",
            opacity: isOpen ? 1 : 0,
            pointerEvents: isOpen ? "auto" : "none",
            transition: "opacity 0.25s ease",
            zIndex: 999,
          }}
        />
        <aside
          role="dialog"
          aria-modal="true"
          aria-label="Main navigation"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            bottom: 0,
            width: "min(340px, 88vw)",
            background: colors.raisedBg,
            zIndex: 1000,
            transform: isOpen ? "translateX(0)" : "translateX(-100%)",
            transition: "transform 0.32s cubic-bezier(0.22, 1, 0.36, 1)",
            boxShadow: isOpen ? `0 0 80px ${colors.shadowStrong}` : "none",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          {content}
        </aside>
      </>
    );
  }

  /* ── Desktop: docked (unchanged from current) ────────── */
  return (
    <aside
      style={{
        width: isOpen ? (isCollapsed ? 76 : 268) : 0,
        overflow: "hidden",
        transition: "width 0.25s cubic-bezier(0.22, 1, 0.36, 1)",
        flexShrink: 0,
        background: colors.raisedBg,
        borderRight: `1px solid ${colors.border}`,
        position: "relative",
      }}
    >
      {isOpen && content}
    </aside>
  );
};

/* ══════════════════════════════════════════════════════════
   Style helpers
   ══════════════════════════════════════════════════════════ */

const styles = {
  logoTile: (c, isMobile, collapsed) => ({
    width: isMobile ? 34 : collapsed ? 34 : 30,
    height: isMobile ? 34 : collapsed ? 34 : 30,
    borderRadius: 9,
    background: c.subtleBg || c.hoverBg,
    border: `1px solid ${c.border}`,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  }),
  groupChildren: {
    position: "relative",
    marginTop: 2,
    marginBottom: 4,
  },
  sectionLabel: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "16px 12px 6px",
    fontSize: 10,
    fontWeight: 800,
    textTransform: "uppercase",
    letterSpacing: 1.2,
  },
};

const iconBtnStyle = (colors) => ({
  width: 28,
  height: 28,
  borderRadius: 7,
  border: "none",
  background: "transparent",
  color: colors.secondaryText,
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "background 0.15s ease, color 0.15s ease",
  flexShrink: 0,
});

const bottomBtnStyle = (colors) => ({
  display: "flex",
  alignItems: "center",
  gap: 10,
  width: "100%",
  padding: "8px 10px",
  borderRadius: 8,
  background: "transparent",
  border: "none",
  color: colors.secondaryText,
  cursor: "pointer",
  fontSize: 12.5,
  fontWeight: 600,
  transition: "background 0.15s ease",
  fontFamily: "inherit",
});

const IconBtn = ({ onClick, title, children }) => {
  const { colors } = useTheme();
  const [hovered, setHovered] = useState(false);
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      title={title}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: 4,
        borderRadius: 6,
        border: "none",
        background: hovered ? colors.hoverBg : "transparent",
        color: hovered ? colors.text : colors.secondaryText,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "background 0.15s ease, color 0.15s ease",
        flexShrink: 0,
      }}
    >
      {children}
    </button>
  );
};

export default Sidebar;